module.exports = __webpack_public_path__ + "static/media/lasso.51ffbbd0.svg";